export const values = (obj) => Object.keys(obj).map((key) => obj[key]);

/**
 * @function createLocalizedUrlPieces
 * @param {string} languageUrl
 * @returns {(pathname: string) => string[]}
 *
 */
export const createLocalizedUrlPieces = (languageUrl) => (pathname) => {
  let urlPieces = pathname.split('/');
  if (urlPieces[1] === languageUrl) {
    urlPieces = [urlPieces[0], ...urlPieces.slice(2)];
  }

  return urlPieces;
};

/**
 * @function createPathname
 * @param {string[]} urlPieces
 * @returns {string}
 */
export const createPathname = (urlPieces) => urlPieces.join('/');

/**
 * @function handleCustomPathnames
 * @param {string} redirectPathname
 * @returns {string}
 */
export const handleCustomPathnames = (redirectPathname) => {
  const customPaths = {
    '/privacy': {
      '/it-it': '/policy',
      '/de-de': '/datenschutz',
      '/fr-fr': '/informations-personnelles',
      '/': 'privacy',
      '/zh-cn': '/privacy',
      '/ja-jp': '/privacy',
      '/ko-kr': '/privacy',
      '/es-es': '/privacy',
      '/es-mx': '/privacy',
      '/es-us': '/privacy',
      '/en-gb': '/privacy',
      '/zh-tw': '/privacy',
      '/fr-ca': '/privacy',
      possibles: [
        '/privacy',
        '/policy',
        '/datenschutz',
        '/informations-personnelles',
      ],
    },
    '/terms': {
      '/it-it': '/termini',
      '/de-de': '/agb',
      '/fr-fr': '/conditions-de-vente',
      '/': 'terms',
      '/zh-cn': '/terms',
      '/ja-jp': '/terms',
      '/ko-kr': '/terms',
      '/es-es': '/terms',
      '/es-mx': '/terms',
      '/es-us': '/terms',
      '/en-gb': '/terms',
      '/zh-tw': '/terms',
      '/fr-ca': '/terms',
      possibles: ['/terms', '/termini', '/agb', '/conditions-de-vente'],
    },
  };

  let language = '/';
  let localizedPath;
  const pathArray = redirectPathname.split(/(?=\/)/g);
  if (pathArray.length > 1) {
    [language, localizedPath] = pathArray;
  } else {
    [localizedPath] = pathArray;
  }

  /* eslint-disable no-restricted-syntax */
  for (const key in customPaths) {
    if (customPaths[key].possibles.includes(localizedPath)) {
      if (customPaths[key][language]) {
        return `${language}${customPaths[key][language]}`;
      }

      return `${language}/${customPaths[key]['/']}`;
    }
  }
  /* eslint-enable */

  return redirectPathname;
};
